module.exports = __webpack_public_path__ + "img/botao_barbacena.d014659e.png";